<p>remove-session works!</p>
